import { Sparkles } from "lucide-react"
import { useTranslation } from "react-i18next"

/**
 * OKS-393 — Recent Activity empty state (UX Spec §3).
 *
 * Shown on both surfaces when the creator has zero qualifying events.
 * Centered icon + title + subtext; the block still renders so the
 * profile isn't missing a section. No "See all" link (nothing more to
 * show).
 */
export function RecentActivityEmptyState() {
  const { t } = useTranslation()
  return (
    <div
      data-testid="recent-activity-empty-state"
      className="text-muted-foreground flex flex-col items-center justify-center gap-2 px-6 py-10 text-center"
      role="status"
    >
      <Sparkles aria-hidden="true" className="size-8 opacity-60" />
      <p className="text-sm font-medium">{t("recent_activity.empty.title")}</p>
      <p className="text-xs">{t("recent_activity.empty.subtitle")}</p>
    </div>
  )
}
